import React from 'react';
import logoImage from '../Img/NursingCareBooking Logo.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
  layout?: 'horizontal' | 'vertical';
}

export const Logo: React.FC<LogoProps> = ({
  size = 'md',
  showText = true,
  className = '',
  layout = 'horizontal',
}) => {
  const sizeClasses = {
    sm: {
      logo: 'h-8 w-8 sm:h-10 sm:w-10',
      text: 'text-sm sm:text-base md:text-lg',
    },
    md: {
      logo: 'h-10 w-10 sm:h-12 sm:w-12',
      text: 'text-base sm:text-lg md:text-xl',
    },
    lg: {
      logo: 'h-14 w-14 sm:h-16 sm:w-16 md:h-18 md:w-18',
      text: 'text-lg sm:text-xl md:text-2xl',
    },
  };

  const layoutClasses = layout === 'vertical'
    ? 'flex flex-col items-start gap-2 sm:gap-3'
    : 'flex items-center gap-2 sm:gap-3';

  return (
    <div className={`${layoutClasses} ${className}`}>
      <img
        src={logoImage}
        alt="NursingCareBooking Logo"
        className={`${sizeClasses[size].logo} object-contain flex-shrink-0`}
      />
      {showText && (
        <span className={`font-bold text-gray-900 break-words ${sizeClasses[size].text}`}>
          NursingCareBooking.com
        </span>
      )}
    </div>
  );
};
